import React, { useState, useEffect } from "react";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import { getArchipelagoConnectionStatus, isArchipelagoConfigured } from "../../Archipelago/Archipelago";
import { ArchipelagoConnectionEvents } from "../../Archipelago/Connection";
import { Settings } from "../../Settings/Settings";
import { Router } from "../../ui/GameRoot";
import { Page } from "../../ui/Router";

export const ArchipelagoConnectionStatus = ({ showIcon }: { showIcon: boolean }): React.ReactElement => {
  const [status, setStatus] = useState(getArchipelagoConnectionStatus());

  useEffect(
    () =>
      ArchipelagoConnectionEvents.subscribe((newStatus) => {
        setStatus(newStatus);
      }),
    [],
  );

  // Players who do not use Archipelago should not see a permanently red icon in their overview.
  // The options page always shows the status, since that is where the feature is configured.
  if (showIcon && !isArchipelagoConfigured()) {
    return <></>;
  }

  let color;
  switch (status) {
    case "Online":
      color = Settings.theme.success;
      break;
    case "Offline":
      color = Settings.theme.error;
      break;
    case "Reconnecting":
      color = Settings.theme.warning;
      break;
  }

  return (
    <Box style={{ display: "flex", flex: 1, justifyContent: "flex-start", alignItems: "center" }}>
      {showIcon ? (
        <IconButton aria-label="Archipelago status" onClick={() => Router.toPage(Page.Options, { tab: "Archipelago" })}>
          <Tooltip title={`Archipelago: ${status}`}>
            <TravelExploreIcon style={{ fontSize: "30px", color }} />
          </Tooltip>
        </IconButton>
      ) : (
        <Typography>
          Status: <span style={{ color }}>{status}</span>
        </Typography>
      )}
    </Box>
  );
};
